import { AppInfoDTO } from 'business/models/Models';
import { GetAppInfoData } from 'business/services/GlobalService';
import { useEffect, useState } from 'react';

const useAppInfo = () => {
  const [appInfo, setAppInfo] = useState<AppInfoDTO | null>();
  useEffect(() => {
    const loadAppInfo = async () => {
      const result = await GetAppInfoData();
      setAppInfo(result);
    };
    loadAppInfo();
  }, []);
  return appInfo;
};

export default useAppInfo;
